import React, { FC } from 'react'

import { Box, Grid, Text } from '../UIKit/system'
import Title from '../title'
import StyledLink from '../styled-link'
import { createMailTo, createTel } from '../../utils/utils'
import { EMAIL_CONTACT, PHONE_CONTACT } from '../../constants'

interface HeaderProps {
  title: string;
  subtitle: string;
}

const Header: FC<HeaderProps> = ({ title, subtitle }) => {
  return (
    <Box mb={[40, 60, 80]} textAlign={'center'}>
      <Text mb={7} fontSizeExtraSmall lightGrey bold>
        {subtitle}
      </Text>
      <Title mb={18}>{title}</Title>
      <Grid gridAutoFlow="column" gridColumnGap={40} justifyContent="center">
        <div>
          <StyledLink
            to={createMailTo(EMAIL_CONTACT)}
            colorPrimary
            fontWeight={400}
          >
            {EMAIL_CONTACT}
          </StyledLink>
        </div>
        <div>
          <StyledLink
            to={createTel(PHONE_CONTACT)}
            colorPrimary
            fontWeight={400}
          >
            {PHONE_CONTACT}
          </StyledLink>
        </div>
        <div>
          <StyledLink to="#chat" colorPrimary fontWeight={400}>
            Chat with us
          </StyledLink>
        </div>
      </Grid>
    </Box>
  )
}

export default Header
